export type SongConfirmKind =
  | { type: 'softDelete' }
  | { type: 'restore' }
  | { type: 'hardDelete' }

/** `reason: z.string().trim().min(8).max(500)` on the RPC side (#1180). */
export const SONG_REASON_MIN = 8
export const SONG_REASON_MAX = 500

export type AdminSongRow = {
  id: string
  title: string
  slug: string
  artist_name: string | null
  visibility: string
  moderation_status: string
  created_at: string
  deleted_at: string | null
  owner_id: string
  owner_username: string | null
  owner_display_name: string | null
}

export function songOwnerLabel(song: AdminSongRow): string {
  return (
    song.owner_display_name ??
    (song.owner_username
      ? `@${song.owner_username}`
      : song.owner_id.slice(0, 8))
  )
}
